import React, { useRef, useState, useEffect } from 'react';
import { Button, TextField, Box, Typography } from '@mui/material';
import { useActivateTwoFactorConfirmMutation } from './hooks/useActivateTwoFactorConfirmMutation';
import TextLanguage from '../../data/TextLanguage.json';
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';

import { useUserSettingsQuery } from './hooks/useUserSettingsQuery';
import { useActivateTwoFactorToggleMutation } from './hooks/useActivateTwoFactorToggleMutation';
import { useQueryClient } from '@tanstack/react-query';
import { useUpdateUserMutation } from './hooks/useUpdateUserMutation';
import debounce from 'lodash.debounce';
import { StyledLoading } from './StyledLoading';
import InfoTwoToneIcon from '@mui/icons-material/InfoTwoTone';
import { StyledTooltip } from '../StyledTooltip';

const exampleHtml =
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45 45" shape-rendering="crispEdges">
        <path fill="#ffffff" d="M0 0h45v45H0z" />
        <path stroke="#000000" d="M4 4.5h7m4 0h1m3 0h2m1 0h1m4 0h1m2 0h1m3 0h7M4 5.5h1m5 0h1m2 0h1m1 0h1m7 0h1m1 0h1m2 0h2m1 0h1m2 0h1m5 0h1M4 6.5h1m1 0h3m1 0h1m1 0h2m1 0h5m3 0h1m1 0h4m2 0h2m1 0h1m1 0h3m1 0h1M4 7.5h1m1 0h3m1 0h1m1 0h1m3 0h2m2 0h2m4 0h1m1 0h1m1 0h3m1 0h1m1 0h3m1 0h1M4 8.5h1m1 0h3m1 0h1m1 0h2m1 0h1m1 0h3m2 0h3m1 0h2m1 0h1m1 0h2m1 0h1m1 0h3m1 0h1M4 9.5h1m5 0h1m1 0h2m1 0h1m1 0h4m1 0h1m1 0h1m4 0h1m1 0h2m1 0h1m5 0h1M4 10.5h7m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h1m1 0h7M12 11.5h2m1 0h1m1 0h3m2 0h2m2 0h5m1 0h1M4 12.5h1m1 0h5m3 0h1m1 0h1m1 0h1m3 0h1m5 0h2m4 0h5M5 13.5h2m1 0h1m2 0h4m2 0h4m1 0h1m1 0h2m1 0h1m2 0h4m4 0h2M8 14.5h1m1 0h4m1 0h1m1 0h1m3 0h3m5 0h1m3 0h1m1 0h1m2 0h3M9 15.5h1m2 0h2m1 0h1m1 0h1m2 0h1m2 0h4m1 0h1m3 0h2m1 0h1m1 0h1m2 0h1M5 16.5h1m1 0h7m1 0h1m1 0h2m2 0h1m2 0h1m1 0h1m3 0h1m3 0h1m1 0h5M5 17.5h1m3 0h1m1 0h1m2 0h1m1 0h1m1 0h2m1 0h1m1 0h2m1 0h2m1 0h1m7 0h1m1 0h1M5 18.5h2m2 0h3m1 0h3m3 0h3m2 0h3m2 0h1m1 0h1m2 0h1m1 0h2m1 0h2M4 19.5h3m2 0h1m2 0h3m3 0h1m2 0h4m1 0h3m1 0h2m4 0h1m3 0h1M5 20.5h4m1 0h1m7 0h3m2 0h1m7 0h3m3 0h2M4 21.5h2m1 0h3m1 0h1m1 0h1m1 0h3m1 0h1m2 0h4m1 0h9m1 0h1m1 0h1M6 22.5h1m1 0h15m1 0h3m1 0h2m2 0h2m1 0h1m1 0h1m1 0h2M5 23.5h2m6 0h3m1 0h1m1 0h1m2 0h2m1 0h1m2 0h1m1 0h2m1 0h1m1 0h1m2 0h2M5 24.5h8m3 0h1m2 0h1m1 0h1m1 0h2m1 0h2m1 0h1m2 0h6m1 0h1M4 25.5h2m1 0h3m2 0h2m8 0h2m3 0h1m4 0h2m3 0h1M6 26.5h1m3 0h3m1 0h5m1 0h1m1 0h1m1 0h1m5 0h2M4 27.5h2m1 0h3m2 0h2m1 0h2m1 0h2m4 0h1m1 0h1m1 0h1m1 0h4m2 0h1M4 28.5h3m1 0h7m2 0h3m2 0h1m8 0h1m1 0h1m1 0h2m1 0h2M4 29.5h6m3 0h1m2 0h2m1 0h2m4 0h2m1 0h1m1 0h1m3 0h1m1 0h2M4 30.5h1m1 0h1m3 0h3m1 0h1m3 0h1m4 0h1m1 0h1m2 0h1m1 0h1m2 0h2m3 0h3M4 31.5h1m1 0h2m5 0h1m1 0h1m1 0h2m1 0h1m4 0h2m1 0h1m1 0h3m1 0h1m1 0h1m1 0h2M4 32.5h1m5 0h1m1 0h1m3 0h2m3 0h1m4 0h1m1 0h2m1 0h6m2 0h2M12 33.5h1m2 0h1m2 0h1m2 0h1m1 0h3m3 0h2m1 0h1m3 0h1M4 34.5h7m7 0h4m2 0h3m1 0h3m1 0h1m1 0h1m1 0h1m2 0h2M4 35.5h1m5 0h1m1 0h6m1 0h5m2 0h1m1 0h1m3 0h1m3 0h1m3 0h1M4 36.5h1m1 0h3m1 0h1m1 0h2m1 0h4m1 0h1m3 0h2m3 0h8m1 0h2M4 37.5h1m1 0h3m1 0h1m1 0h1m1 0h2m3 0h1m2 0h1m4 0h1m2 0h1m1 0h3m1 0h1M4 38.5h1m1 0h3m1 0h1m1 0h2m1 0h2m1 0h3m2 0h1m2 0h2m1 0h1m2 0h1m2 0h1m2 0h1m1 0h1M4 39.5h1m5 0h1m2 0h4m1 0h2m2 0h1m1 0h2m1 0h2m2 0h1m2 0h1m3 0h1m1 0h1M4 40.5h7m1 0h2m1 0h3m1 0h4m3 0h2m1 0h1m2 0h1m1 0h2m3 0h2" />
    </svg>


export const UserSettings = ({ setsnackbarStatus, lang, demoMode = 0 }) => {
    const [showQR, setShowQR] = useState({ state: false, code: '' });
    const [confirmationCode, setConfirmationCode] = useState('');

    const activateTwoFactorToggleMutation = useActivateTwoFactorToggleMutation({ setsnackbarStatus, setShowQR });
    const activateTwoFactorConfirmMutation = useActivateTwoFactorConfirmMutation({ setsnackbarStatus, setShowQR });

    const queryClient = useQueryClient();
    const validateData = queryClient.getQueryData(['validate']);
    const confirmedUserID = validateData?.data?.userID;
    const numberRegex = /\d+/g;
    const ClientMode = (numberRegex.test(confirmedUserID));

    const userSettingsQuery = useUserSettingsQuery();

    const userData = userSettingsQuery?.data?.data || null;

    const handleActivate2FA = () => {
        activateTwoFactorToggleMutation.mutate();
    };

    const handleConfirm = () => {
        activateTwoFactorConfirmMutation.mutate({ token: confirmationCode });
    };

    const userMutation = useUpdateUserMutation({ setsnackbarStatus });


    const [mailInfo, setMailInfo] = useState(userData?.mailInfo);
    const [mailPayment, setMailPayment] = useState(userData?.mailPayment);

    useEffect(() => {
        if (userSettingsQuery.isSuccess && userData) {
            setMailInfo(userData.mailInfo);
            setMailPayment(userData.mailPayment);
        }
    }, [userSettingsQuery.isSuccess, userData]);

    const debouncedUpdate = ({ key, newValue, oldData, reset }) => debounce(() => {
        queryClient.setQueryData(['userSettings'], (prevData) => { // Optimistic Update
            return { ...prevData, [key]: newValue };
        });

        const updaterData = {
            username: oldData.username,
            mailPayment: oldData.mailPayment,
            mailInfo: oldData.mailInfo,
            [key]: newValue,
        };

        userMutation.mutate({ updaterData, oldData, key, reset });
    },
        1000);

    const mailInfoDebounceRef = useRef(null);
    const mailPaymentDebounceRef = useRef(null);

    const handleMailInfo = (e) => {

        setMailInfo(e.target.value);
        mailInfoDebounceRef.current?.cancel();
        mailInfoDebounceRef.current = debouncedUpdate({ key: 'mailInfo', newValue: e.target.value, oldData: userData, reset: setMailInfo });
        mailInfoDebounceRef.current();

    };
    const handleMailPayment = (e) => {

        setMailPayment(e.target.value);
        mailPaymentDebounceRef.current?.cancel();
        mailPaymentDebounceRef.current = debouncedUpdate({ key: 'mailPayment', newValue: e.target.value, oldData: userData, reset: setMailPayment });
        mailPaymentDebounceRef.current();
    };
    const selectableStyle = demoMode === 2 ? { pointerEvents: 'none', userSelect: 'none' } : {};

    return (
        userSettingsQuery.isSuccess ? <div className='InfoActivityLogSection' style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '1.5rem' }}>

            {demoMode !== 2 &&
                <div className='SettingRowWrapper'>
                    <div className='SettingRowContainer' >
                        <Typography style={{ fontWeight: 'bold', pointerEvents: 'none', userSelect: 'none' }}>
                            {TextLanguage['AuthenticatorApp'][lang]}
                        </Typography>
                        <div className='SettingRowButtonContainer'>
                            <Button
                                disabled={demoMode === 1}
                                variant="contained" color="primary" onClick={handleActivate2FA}>
                                {userData?.isTotpActive ? TextLanguage['Remove'][lang] : TextLanguage['Setup'][lang]}
                                <QrCodeScannerIcon sx={{ marginLeft: '0.5rem' }} />
                            </Button>
                        </div>

                    </div>
                    {((showQR.state && !!showQR?.code) || (demoMode === 1)) && (
                        <div style={{ height: 'clamp(10rem, 100%, 30vh)', marginTop: '0.75rem' }}>
                            <div style={{ justifyContent: 'center', display: 'flex', padding: '1rem', background: 'var(--color-main-theme-darker)', borderRadius: '12px 12px 0 0' }}>
                                <Typography sx={{ fontWeight: 'bold', pointerEvents: 'none', userSelect: 'none' }}>
                                    {TextLanguage['ScanQRCode'][lang]}
                                </Typography>
                            </div>

                            {/* <img alt='QR Code' src={`${showQR?.code}`} style={{ height: 'auto', width: '100%' }} /> */}
                            {(demoMode === 1) ? exampleHtml : <div dangerouslySetInnerHTML={{ __html: showQR?.code }} />}


                            <TextField
                                label="Enter Confirmation Code"
                                variant="outlined"
                                sx={{ width: '100%' }}
                                margin="normal"
                                value={confirmationCode}
                                onChange={(e) => setConfirmationCode(e.target.value)}
                            />
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0.5rem 0', width: '100%' }}>
                                <Button disabled={demoMode === 1} variant="contained" onClick={handleConfirm} fullWidth>
                                    {TextLanguage['Confirm'][lang]}
                                </Button>
                            </div>
                        </div>
                    )}
                </div>}


            {ClientMode && (demoMode !== 1) &&
                <div className='SettingRowWrapper'>
                    <div className='SettingRowContainer' >
                        <div className='SettingRowButtonContainer'>
                            <Typography style={{ fontWeight: 'bold', pointerEvents: 'none', userSelect: 'none' }}>
                                {TextLanguage['MailInfo'][lang]}
                            </Typography>
                            <StyledTooltip title={TextLanguage['MailInfoTooltip'][lang]} placement="top">
                                <InfoTwoToneIcon sx={{color:'var(--color-main-theme-light)'}}/>
                            </StyledTooltip>
                        </div>
                    </div>
                    <TextField
                        label='email1, email2, email3...'
                        InputLabelProps={{ shrink: true }}
                        sx={{ width: '100%', ...selectableStyle }}
                        margin="normal"
                        value={mailInfo}
                        onChange={handleMailInfo}
                    />
                </div>
            }
            {ClientMode && (demoMode !== 1) &&
                <div className='SettingRowWrapper'>
                    <div className='SettingRowContainer' >
                        <div className='SettingRowButtonContainer'>
                            <Typography style={{ fontWeight: 'bold', pointerEvents: 'none', userSelect: 'none' }}>
                                {TextLanguage['MailPayment'][lang]}
                            </Typography>
                            <StyledTooltip title={TextLanguage['MailPaymentTooltip'][lang]} placement="top">
                                <InfoTwoToneIcon sx={{color:'var(--color-main-theme-light)'}} />
                            </StyledTooltip>
                        </div>
                    </div>
                    <TextField
                        label='email1, email2, email3...'
                        InputLabelProps={{ shrink: true }}
                        sx={{ width: '100%', ...selectableStyle }}
                        margin="normal"
                        value={mailPayment}
                        onChange={handleMailPayment}
                    />
                </div>
            }

        </div>
            :
            <div className='InfoActivityLogSection' style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '1.5rem', justifyContent: 'center' }}>
                {userSettingsQuery.isLoading && <StyledLoading />}
            </div>


    );
};

